import { queryKeys } from '../keys'
import { DEFAULT_RETRY_MUTATION } from '../config'
import type { QueryClient } from '@tanstack/react-query'
import type { GetBookingTransportationResponse } from '@/types/booking'
import { addOnsService } from '@/services'

function updateAddOnsPointToPoints(queryClient: QueryClient) {
  return queryClient.setMutationDefaults(queryKeys.addOns.patchPTP(), {
    retry: DEFAULT_RETRY_MUTATION,
    mutationFn: (
      payload: Parameters<typeof addOnsService.patchPointToPoints>[0],
    ) => addOnsService.patchPointToPoints(payload),
    onSuccess: (_, payload) => {
      const transportation =
        queryClient.getQueryData<GetBookingTransportationResponse>(
          queryKeys.booking.transportation(payload.id),
        )
      if (transportation) {
        queryClient.invalidateQueries({
          queryKey: queryKeys.booking.detail(
            transportation.data.booked_transportation.adhoc_booking_id,
          ),
        })
      }
      queryClient.invalidateQueries({
        queryKey: queryKeys.booking.transportation(payload.id),
      })
    },
  })
}

function updateAddOnsHourly(queryClient: QueryClient) {
  return queryClient.setMutationDefaults(queryKeys.addOns.patchHourly(), {
    retry: DEFAULT_RETRY_MUTATION,
    mutationFn: (payload: Parameters<typeof addOnsService.patchHourly>[0]) =>
      addOnsService.patchHourly(payload),
    onSuccess: (_, payload) => {
      const transportation =
        queryClient.getQueryData<GetBookingTransportationResponse>(
          queryKeys.booking.transportation(payload.id),
        )
      if (transportation) {
        queryClient.invalidateQueries({
          queryKey: queryKeys.booking.detail(
            transportation.data.booked_transportation.adhoc_booking_id,
          ),
        })
      }
      queryClient.invalidateQueries({
        queryKey: queryKeys.booking.transportation(payload.id),
      })
    },
  })
}

function postSelectAddOns(queryClient: QueryClient) {
  return queryClient.setMutationDefaults(queryKeys.addOns.postSelected(), {
    retry: DEFAULT_RETRY_MUTATION,
    mutationFn: (
      payload: Parameters<typeof addOnsService.getSelectedAddOns>[0],
    ) => addOnsService.getSelectedAddOns(payload),
    onMutate: async (payload) => {
      await queryClient.cancelQueries({
        queryKey: queryKeys.booking.transportation(payload.id),
      })
    },
  })
}

export function registerAddOnsMutations(queryClient: QueryClient) {
  updateAddOnsPointToPoints(queryClient)
  updateAddOnsHourly(queryClient)
  postSelectAddOns(queryClient)
}
